import { useOmniBox } from '@/context/OmniBoxContext';

interface UseOmniBoxStateReturn {
  isExpanded: boolean;
  expand: () => void;
  collapse: () => void;
  toggle: () => void;
}

export const useOmniBoxState = (): UseOmniBoxStateReturn => {
  return useOmniBox();
};
